import {ApiResponse, apiClient} from "@/shared/api";
import { Contact } from "../model";

export const updateContact = (userId: string, firstName: string, lastName: string): Promise<ApiResponse<Contact>> => {
  return apiClient(`/api/contacts/${userId}`, "put", {firstName, lastName});
};
